<template>
  <div class="pingan-trunk-user">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>平安干线保用户</span>
      </div>
      
      <!-- 搜索工具栏 -->
      <div class="search-toolbar">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="自定义检索">
            <el-select v-model="searchType" placeholder="请选择" @change="handleSearchTypeChange">
              <el-option label="按公司名称" value="1"></el-option>
              <el-option label="按手机号码" value="2"></el-option>
              <el-option label="按注册时间" value="3"></el-option>
              <el-option label="按平台名称" value="6"></el-option>
              <el-option label="按是否在白名单" value="7"></el-option>
              <el-option label="按开票类型" value="8"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item v-if="searchType === '1'">
            <el-input v-model="searchForm.companyName" placeholder="公司名称" clearable></el-input>
          </el-form-item>
          
          <el-form-item v-if="searchType === '2'">
            <el-input v-model="searchForm.mobile" placeholder="手机号码" clearable></el-input>
          </el-form-item>
          
          <el-form-item v-if="searchType === '3'">
            <el-date-picker
              v-model="searchForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp">
            </el-date-picker>
          </el-form-item>
          
          <el-form-item v-if="searchType === '6'">
            <el-select v-model="searchForm.appId" placeholder="请选择平台">
              <el-option
                v-for="item in appList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item v-if="searchType === '7'">
            <el-select v-model="searchForm.whiteList" placeholder="请选择">
              <el-option label="在白名单" value="true"></el-option>
              <el-option label="不在白名单" value="false"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item v-if="searchType === '8'">
            <el-select v-model="searchForm.vatInvoiceOpenType" placeholder="请选择开票类型">
              <el-option label="开票" value="1"></el-option>
              <el-option label="不开票" value="2"></el-option>
              <el-option label="待定" value="4"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item>
            <el-input v-model="searchForm.channel" placeholder="渠道商" clearable></el-input>
          </el-form-item>
          
          <el-form-item>
            <el-checkbox v-model="searchForm.orderByExpense">按消费金额排序</el-checkbox>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">全部</el-button>
            <el-button type="primary" @click="handleCreateUser">创建用户</el-button>
            <el-button type="success" @click="handleExportExcel">导出Excel</el-button>
          </el-form-item>
        </el-form>
      </div>
      
      <!-- 数据表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        v-loading="loading"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="company_name" label="公司" width="280" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.company_id > 0" class="company-link" @click="viewCompanyDetail(scope.row.company_id)">
              {{ scope.row.company_name }}
            </span>
            <span v-else>{{ scope.row.company_name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" width="180" align="center"></el-table-column>
        <el-table-column prop="app_name" label="平台名称" width="200" align="center"></el-table-column>
        <el-table-column prop="top_channel_name" label="顶级渠道" width="160" align="center"></el-table-column>
        <el-table-column prop="channel_name" label="渠道商" width="160" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.channel_name">
              {{ scope.row.channel_name }}({{ scope.row.alias }})
            </span>
            <span v-else>{{ scope.row.alias }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="insurance_company_name" label="保险公司" width="250" align="center"></el-table-column>
        <el-table-column prop="policy_no" label="大保单号" width="260" align="center"></el-table-column>
        <el-table-column prop="vat_invoice_type" label="开票类型" width="80" :formatter="vatInvoiceTypeFormat" align="center"></el-table-column>
        <el-table-column prop="deposit" label="总充值金额(元)" width="120" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="expense" label="消费金额(元)" width="120" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="balance" label="账户余额(元)" width="120" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="last_month_balance" label="上月底账户余额(元)" width="150" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="new_balance" label="当前保单金额(元)" width="130" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="offline_deposit" label="线下充值总金额(元)" width="150" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="offline_expense" label="线下充值支出总金额(元)" width="170" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="offline_balance" label="线下充值当前余额(元)" width="160" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="agreement_url" label="协议文件" width="80" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.agreement_url" class="link" @click="viewUrl(scope.row.agreement_url)">查看</span>
          </template>
        </el-table-column>
        <el-table-column prop="policy_url" label="电子保单" width="80" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.policy_url" class="link" @click="viewUrl(scope.row.policy_url)">查看</span>
          </template>
        </el-table-column>
        <el-table-column prop="effected_at" label="生效时间" width="160" :formatter="dateFormat" align="center"></el-table-column>
        <el-table-column prop="expired_at" label="失效时间" width="160" :formatter="dateFormat" align="center"></el-table-column>
        <el-table-column prop="created_at" label="注册时间" width="160" :formatter="dateFormat" align="center"></el-table-column>
        <el-table-column prop="note" label="备注" width="200" align="center"></el-table-column>
        <el-table-column prop="disabled" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.disabled ? 'danger' : 'success'">
              {{ scope.row.disabled ? '锁定' : '正常' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="is_on_white_list" label="是否在白名单" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.is_on_white_list ? 'success' : 'info'">
              {{ scope.row.is_on_white_list ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="600" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.disabled"
              size="mini"
              type="success"
              @click="handleUpdateStatus(scope.row.id, false, 'status')">
              解锁
            </el-button>
            <template v-else>
              <el-button size="mini" type="warning" @click="handleUpdateStatus(scope.row.id, true, 'status')">锁定</el-button>
              <el-button size="mini" @click="handleChangeChannel(scope.row)">变更渠道</el-button>
            </template>
            <el-button size="mini" @click="handleInvoice(scope.row)">开票信息</el-button>
            <el-button
              v-if="scope.row.is_on_white_list"
              size="mini"
              type="danger"
              @click="handleUpdateStatus(scope.row.id, false, 'white_list')">
              移出白名单
            </el-button>
            <el-button
              v-else
              size="mini"
              type="success"
              @click="handleUpdateStatus(scope.row.id, true, 'white_list')">
              移入白名单
            </el-button>
            <el-button size="mini" @click="handleDeposit(scope.row)">充值</el-button>
            <el-button size="mini" @click="handleAgreement(scope.row)">录入线下协议/保单</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 15, 20]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px;">
      </el-pagination>
    </el-card>
    
    <!-- 创建用户弹窗 -->
    <CreateUser 
      :visible.sync="showCreateDialog"
      @success="handleCreateSuccess"
      @close="handleCreateClose"
    />
    
    <!-- 变更渠道弹窗 -->
    <ChangeChannel 
      :visible.sync="showChangeChannelDialog"
      :user-id="currentUserId"
      :current-user="currentUser"
      @success="handleChangeChannelSuccess"
      @close="handleChangeChannelClose"
    />
    
    <!-- 开票信息弹窗 -->
    <InvoiceInfo 
      :visible.sync="showInvoiceDialog"
      :user-id="currentUserId"
      @success="handleInvoiceSuccess"
      @close="handleInvoiceClose"
    />
    
    <!-- 充值弹窗 -->
    <Deposit 
      :visible.sync="showDepositDialog"
      :user-id="currentUserId"
      @success="handleDepositSuccess"
      @close="handleDepositClose"
    />
    
    <!-- 录入线下协议/保单弹窗 -->
    <AgreementPolicy 
      :visible.sync="showAgreementPolicyDialog"
      :user-id="currentUserId"
      @success="handleAgreementPolicySuccess"
      @close="handleAgreementPolicyClose"
    />
  </div>
</template>

<script>
import { formatDate, formatMoney } from '@/utils/formatter'
import { 
  paGxbUserList, 
  getAppList, 
  getChannelList, 
  updatePaGxbUser, 
  disabledPaGxbUser, 
  createPaGxbUser,
  getPaGxbUserInfo,
  updatePaGxbUserInvoice
} from '@/api/member'
import CreateUser from './pinganComponents/CreateUser.vue'
import ChangeChannel from './pinganComponents/ChangeChannel.vue'
import InvoiceInfo from './pinganComponents/InvoiceInfo.vue'
import Deposit from './pinganComponents/Deposit.vue'
import AgreementPolicy from './pinganComponents/AgreementPolicy.vue'
import { jsonToExcel } from './pinganComponents/utils/exportExcel.js'

export default {
  name: 'PingAnTrunkUser',
  components: {
    CreateUser,
    ChangeChannel,
    InvoiceInfo,
    Deposit,
    AgreementPolicy
  },
  data() {
    return {
      loading: false,
      searchType: '1',
      searchForm: {
        companyName: '',
        mobile: '',
        dateRange: [],
        appId: '',
        whiteList: '',
        vatInvoiceOpenType: '',
        channel: '',
        orderByExpense: false
      },
      tableData: [],
      multipleSelection: [],
      pagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      },
      appList: [],
      channelList: [],
      // 弹窗相关
      showCreateDialog: false,
      showChangeChannelDialog: false,
      showInvoiceDialog: false,
      showDepositDialog: false,
      showAgreementPolicyDialog: false,
      currentUserId: '',
      currentUser: {}
    }
  },
  created() {
    this.fetchData()
    this.fetchAppList()
    this.fetchChannelList()
  },
  methods: {
    // 获取数据
    async fetchData() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.currentPage,
          rows: this.pagination.pageSize,
          type: 2,
          insurance_type: 144,
          ...this.buildSearchParams()
        }
        
        const res = await paGxbUserList(params)
        this.tableData = res.rows || []
        this.pagination.total = res.total || 0
      } catch (error) {
        console.error('获取平安干线保用户列表失败:', error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    
    // 构建搜索参数
    buildSearchParams() {
      const params = {}
      
      if (this.searchForm.orderByExpense) {
        params.order_by_expense = true
      }
      
      switch (this.searchType) {
        case '1':
          if (this.searchForm.companyName) {
            params.company_name = this.searchForm.companyName
          }
          break
        case '2':
          if (this.searchForm.mobile) {
            params.mobile = this.searchForm.mobile
          }
          break
        case '3':
          if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
            params.begin_date = Math.floor(this.searchForm.dateRange[0] / 1000)
            params.end_date = Math.floor(this.searchForm.dateRange[1] / 1000)
          }
          break
        case '6':
          if (this.searchForm.appId) {
            params.app_id = this.searchForm.appId
          }
          break
        case '7':
          if (this.searchForm.whiteList) {
            params.is_on_white_list = this.searchForm.whiteList
          }
          break
        case '8':
          if (this.searchForm.vatInvoiceOpenType) {
            params.vat_invoice_open_type = this.searchForm.vatInvoiceOpenType
          }
          break
      }
      
      if (this.searchForm.channel) {
        // 这里需要根据实际需求处理渠道搜索
        params.channel_name = this.searchForm.channel
      }
      
      return params
    },
    
    // 获取平台列表
    async fetchAppList() {
      try {
        const res = await getAppList()
        this.appList = res.rows || []
      } catch (error) {
        console.error('获取平台列表失败:', error)
      }
    },
    
    // 获取渠道列表
    async fetchChannelList() {
      try {
        const res = await getChannelList()
        this.channelList = res.rows || []
      } catch (error) {
        console.error('获取渠道列表失败:', error)
      }
    },
    
    // 搜索类型变化
    handleSearchTypeChange() {
      // 重置搜索表单
      this.searchForm.companyName = ''
      this.searchForm.mobile = ''
      this.searchForm.dateRange = []
      this.searchForm.appId = ''
      this.searchForm.whiteList = ''
      this.searchForm.vatInvoiceOpenType = ''
    },
    
    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchData()
    },
    
    // 重置
    handleReset() {
      this.searchForm = {
        companyName: '',
        mobile: '',
        dateRange: [],
        appId: '',
        whiteList: '',
        vatInvoiceOpenType: '',
        channel: '',
        orderByExpense: false
      }
      this.searchType = '1'
      this.pagination.currentPage = 1
      this.fetchData()
    },
    
    // 创建用户
    handleCreateUser() {
      this.showCreateDialog = true;
    },
    
    // 创建用户成功回调
    handleCreateSuccess() {
      this.fetchData()
    },
    
    // 创建用户关闭回调
    handleCreateClose() {
      this.showCreateDialog = false;
    },
    
    // 导出Excel
    async handleExportExcel() {
      try {
        // 显示导出中提示
        const loading = this.$loading({
          lock: true,
          text: '正在导出数据...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        
        // 获取所有数据（可能需要分页处理）
        const params = {
          page: 1,
          rows: 10000, // 假设最多导出10000条数据
          type: 2,
          insurance_type: 144,
          ...this.buildSearchParams()
        };
        
        const res = await paGxbUserList(params);
        
        if (res.err_code === 0) {
          const exportData = res.rows || [];
          
          // 定义表头
          const headers = [
            { title: '公司', key: 'company_name' },
            { title: '手机号', key: 'mobile' },
            { title: '平台名称', key: 'app_name' },
            { title: '顶级渠道', key: 'top_channel_name' },
            { title: '渠道商', key: 'channel_name' },
            { title: '保险公司', key: 'insurance_company_name' },
            { title: '大保单号', key: 'policy_no' },
            { title: '开票类型', key: 'vat_invoice_type' },
            { title: '总充值金额(元)', key: 'deposit' },
            { title: '消费金额(元)', key: 'expense' },
            { title: '账户余额(元)', key: 'balance' },
            { title: '上月底账户余额(元)', key: 'last_month_balance' },
            { title: '当前保单金额(元)', key: 'new_balance' },
            { title: '线下充值总金额(元)', key: 'offline_deposit' },
            { title: '线下充值支出总金额(元)', key: 'offline_expense' },
            { title: '线下充值当前余额(元)', key: 'offline_balance' },
            { title: '协议文件', key: 'agreement_url' },
            { title: '电子保单', key: 'policy_url' },
            { title: '生效时间', key: 'effected_at' },
            { title: '失效时间', key: 'expired_at' },
            { title: '注册时间', key: 'created_at' },
            { title: '备注', key: 'note' },
            { title: '状态', key: 'disabled' },
            { title: '是否在白名单', key: 'is_on_white_list' }
          ];
          
          // 格式化数据
          const formattedData = exportData.map(item => {
            return {
              ...item,
              vat_invoice_type: this.vatInvoiceTypeFormat(item, null, item.vat_invoice_type),
              deposit: formatMoney(item.deposit),
              expense: formatMoney(item.expense),
              balance: formatMoney(item.balance),
              last_month_balance: formatMoney(item.last_month_balance),
              new_balance: formatMoney(item.new_balance),
              offline_deposit: formatMoney(item.offline_deposit),
              offline_expense: formatMoney(item.offline_expense),
              offline_balance: formatMoney(item.offline_balance),
              effected_at: formatDate(item.effected_at),
              expired_at: formatDate(item.expired_at),
              created_at: formatDate(item.created_at),
              disabled: item.disabled ? '锁定' : '正常',
              is_on_white_list: item.is_on_white_list ? '是' : '否',
              channel_name: item.channel_name ? `${item.channel_name}(${item.alias})` : item.alias
            };
          });
          
          // 导出文件
          const fileName = `平安干线保用户列表_${new Date().toISOString().slice(0, 10)}.csv`;
          const success = jsonToExcel(formattedData, headers, fileName);
          
          if (success) {
            this.$message.success('导出成功');
          } else {
            this.$message.error('导出失败');
          }
        } else {
          this.$message.error('导出失败: ' + res.err_msg);
        }
        
        loading.close();
      } catch (error) {
        console.error('导出Excel失败:', error);
        this.$message.error('导出失败: ' + error.message);
      }
    },
    
    // 查看公司详情
    viewCompanyDetail(companyId) {
      this.$message.info(`查看公司详情，ID: ${companyId}`)
    },
    
    // 查看URL
    viewUrl(url) {
      window.open(url, '_blank')
    },
    
    // 变更渠道
    handleChangeChannel(row) {
      this.currentUserId = row.id
      this.currentUser = row
      // 确保currentUser有app_id属性
      if (!this.currentUser.app_id && this.currentUser.app_id !== 0) {
        console.warn('当前用户没有app_id属性:', this.currentUser)
      }
      this.showChangeChannelDialog = true
    },

    // 变更渠道成功回调
    handleChangeChannelSuccess() {
      this.fetchData()
    },

    // 变更渠道关闭回调
    handleChangeChannelClose() {
      this.showChangeChannelDialog = false
    },
    
    // 开票信息
    handleInvoice(row) {
      this.currentUserId = row.id
      this.currentUser = row
      this.showInvoiceDialog = true
    },
    
    // 开票信息关闭回调
    handleInvoiceClose() {
      this.showInvoiceDialog = false
    },

    // 开票信息成功回调
    handleInvoiceSuccess() {
      this.fetchData()
    },
    
    // 充值
    handleDeposit(row) {
      this.currentUserId = row.id
      this.currentUser = row
      this.showDepositDialog = true
    },

    // 充值成功回调
    handleDepositSuccess() {
      this.fetchData()
    },

    // 充值关闭回调
    handleDepositClose() {
      this.showDepositDialog = false
    },

    // 录入协议保单
    handleAgreement(row) {
      this.currentUserId = row.id
      this.currentUser = row
      this.showAgreementPolicyDialog = true
    },

    // 录入协议保单成功回调
    handleAgreementPolicySuccess() {
      this.fetchData()
    },

    // 录入协议保单关闭回调
    handleAgreementPolicyClose() {
      this.showAgreementPolicyDialog = false
    },
    
    // 更新状态
    async handleUpdateStatus(userId, status, action) {
      try {
        // 获取要操作的用户信息，用于显示确认对话框
        const user = this.tableData.find(item => item.id === userId);
        const userName = user ? (user.mobile || user.username || userId) : userId;
        const tip = status ? (action === 'status' ? '锁定' : '移入白名单') : (action === 'status' ? '解锁' : '移出白名单');
        
        // 显示确认对话框
        await this.$confirm(`您确认想要修改用户 ${userName} 的状态为"${tip}"吗？`, '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        let res;
        // 根据操作类型调用不同的接口
        if (action === 'white_list') {
          // 白名单操作使用updatePaGxbUser接口
          const params = {
            user_id: userId,
            is_on_white_list: status
          };
          res = await updatePaGxbUser(params);
        } else {
          // 锁定/解锁操作使用disabledPaGxbUser接口
          const params = {
            user_id: userId,
            disabled: status
          };
          res = await disabledPaGxbUser(params);
        }
        
        if (res.err_code === 0) {
          this.$message.success('修改成功')
          // 重新加载数据
          this.fetchData()
        } else {
          this.$message.error('修改失败: ' + res.err_msg)
        }
      } catch (error) {
        // 用户取消操作或API调用失败
        if (error !== 'cancel') {
          console.error('更新状态失败:', error)
          this.$message.error('修改失败: ' + (error.message || '未知错误'))
        }
      }
    },
    
    // 开票类型格式化
    vatInvoiceTypeFormat(row, column, cellValue) {
      let map = ''
      if (row.vat_invoice_open_type == 1) {
        if (cellValue == 1) {
          map = '普票'
        } else if (cellValue == 2) {
          map = '专票'
        }
      } else if (row.vat_invoice_open_type == 2) {
        map = '不开票'
      } else {
        map = '待定'
      }
      return map
    },
    
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    
    // 分页大小变化
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.fetchData()
    },
    
    // 当前页变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchData()
    },
    
    // 金额格式化
    moneyFormat(row, column, cellValue) {
      return formatMoney(cellValue)
    },
    
    // 日期格式化
    dateFormat(row, column, cellValue) {
      return formatDate(cellValue)
    }
  }
}
</script>

<style lang="less" scoped>
.pingan-trunk-user {
  padding: 20px;
  
  .search-toolbar {
    margin-bottom: 20px;
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
  
  .company-link, .link {
    color: #409EFF;
    cursor: pointer;
    
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>